// extracted by mini-css-extract-plugin
export default {"container":"ae641978","title":"cc91446c"};